import { render, staticRenderFns } from "./blade-faq.vue?vue&type=template&id=30390e2e&scoped=true&"
import script from "./blade-faq.vue?vue&type=script&lang=js&"
export * from "./blade-faq.vue?vue&type=script&lang=js&"
import style0 from "./blade-faq.vue?vue&type=style&index=0&id=30390e2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30390e2e",
  null
  
)

export default component.exports